import { render, staticRenderFns } from "./ribbonPreprod.vue?vue&type=template&id=ba9ef7b6&scoped=true"
import script from "./ribbonPreprod.vue?vue&type=script&lang=js"
export * from "./ribbonPreprod.vue?vue&type=script&lang=js"
import style0 from "./ribbonPreprod.vue?vue&type=style&index=0&id=ba9ef7b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9ef7b6",
  null
  
)

export default component.exports